import { z } from 'zod';
/** Risposta di `GET /api/v1/health`: dice solo che il processo risponde. */
export const healthResponseSchema = z.object({
    status: z.literal('ok'),
    version: z.string(),
    uptimeSeconds: z.number(),
});
/**
 * Risposta di `GET /api/v1/ready`: dice se l'applicativo può ricevere traffico.
 * `checks` resta leggibile anche quando l'esito è negativo — una sonda che dice
 * solo «no» costringe a cercare altrove il perché.
 */
export const readyResponseSchema = z.object({
    status: z.enum(['ready', 'not-ready']),
    checks: z.object({
        database: z.enum(['ok', 'ko']),
        migrations: z.enum(['ok', 'ko', 'unknown']),
    }),
    detail: z.string().optional(),
});
//# sourceMappingURL=health.js.map